import $ from 'jquery';

$(function () {
    'use strict';

    let resizedFinished = [];

    const isTouchDevice = 'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0;

    const buttonsDefault = [
        { extend: 'csv', text: 'Download CSV', className: 'mr-4' },
        { extend: 'copy', text: 'Copy to Clipboard' }
    ];

    const publicAjaxTableDefaults = {
        deferRender: true,
        processing: true,
        searchDelay: 250,
        pageLength: 25
    };

    function publicAjaxTableOptions(options) {
        return $.extend(true, {}, publicAjaxTableDefaults, options);
    }

    const formats = {
        number: {
            human: new Intl.NumberFormat('en-US', {
                maximumFractionDigits: 0
            })
        },
        USD: {
            human: new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 0
            })
        }
    };

    function formatHuman(value, unit) {
        const numericValue = typeof value === 'string'
            ? Number(value.replace(/[^0-9.-]/g, ''))
            : value;

        if (numericValue == null) return value;

        if (unit === 'USD') {
            return formats.USD.human.format(numericValue);
        }

        // number
        return formats.number.human.format(numericValue);
    }

    function railsEnv() {
        return $('#mini-profiler').length ? 'development' : 'production';
    }

    function debug(msg) {
        if (railsEnv() == 'development') {
            console.log(msg);
        }
    }

    function datatableHeaderOffset() {
        return $('nav').parent().css('position') === 'fixed' ? $('nav').outerHeight() : 0;
    }

    const tableWidthStyleTagId = 'datatable-width-rules';
    const tableWidthRulesApplied = new Set();

    function ensureTableWidthStyleTag() {
        let styleTag = document.getElementById(tableWidthStyleTagId);
        if (styleTag) return styleTag;

        styleTag = document.createElement('style');
        styleTag.id = tableWidthStyleTagId;
        document.head.appendChild(styleTag);
        return styleTag;
    }

    function applyTableWidthRules(tableId) {
        if (!tableId || tableWidthRulesApplied.has(tableId)) return;

        const rules = [];
        $('#' + tableId + ' th').each(function (i, obj) {
            const width = $(obj).css('width');
            if (!width) return;
            rules.push('#' + tableId + '_wrapper th:nth-child(' + (i + 1) + '){ width: ' + width + '; }');
        });

        if (rules.length === 0) {
            tableWidthRulesApplied.add(tableId);
            return;
        }

        try {
            const styleTag = ensureTableWidthStyleTag();
            styleTag.appendChild(document.createTextNode('\n' + rules.join('\n') + '\n'));
            tableWidthRulesApplied.add(tableId);
        } catch (error) {
            console.warn('DataTables width rule injection failed for #' + tableId, error);
        }
    }

    function applyResponsiveCardLabels(tableNode) {
        if (!tableNode || !tableNode.classList || !tableNode.classList.contains('table-responsive-cards')) return;

        tableNode.classList.add('lp-data-table');

        const headers = Array.from(tableNode.querySelectorAll('thead th')).map((headerNode) => {
            return (headerNode.textContent || '').trim();
        });
        if (headers.length === 0) return;

        tableNode.querySelectorAll('tbody tr').forEach((row) => {
            Array.from(row.children).forEach((cellNode, index) => {
                if (!cellNode || cellNode.tagName !== 'TD') return;
                if (headers[index]) {
                    cellNode.setAttribute('data-label', headers[index]);
                }
            });
        });
    }

    function applyResponsiveCardLabelsToAll() {
        document.querySelectorAll('table.table-responsive-cards').forEach((tableNode) => {
            applyResponsiveCardLabels(tableNode);
        });
    }

    function enhanceDataTableShell(tableNode) {
        if (!tableNode) return;

        tableNode.classList.add('lp-data-table');
        const wrapper = tableNode.closest('.dataTables_wrapper');
        if (wrapper) {
            wrapper.classList.add('lp-datatable-wrapper');
            if (tableNode.classList.contains('lp-public-data-table')) {
                wrapper.classList.add('lp-public-datatable-wrapper');
            }
        }
    }

    $.extend(true, $.fn.dataTable.defaults, {
        autoWidth: false,
        bLengthChange: false,
        createdRow: (row, data, dataIndex, cells) => {
            let html_columns = cells.length;
            let json_columns = data.length;
            if (html_columns != json_columns) {
                debug('Wrong columns count for HTML table: Datatables columns = ' + html_columns + ', Json columns = ' + json_columns);
            }

            if (!row.className) {
                $(row).addClass('bg-white even:bg-slate-50 hover:bg-cyan-50/50');
            }
        },
        fixedHeader: ({ headerOffset: datatableHeaderOffset() }),
        language: { search: 'Filter rows' },
        order: [],
        pageLength: 50,
        scrollX: true,
        initComplete: function (settings, json) {
            $('.dataTables_filter input[type=search]').each(function () {
                const filterId = $('.dataTables_filter').attr('id');
                const inputId = filterId ? `${filterId}_input` : 'datatable_filter_input';
                $(this).attr('id', inputId);
                $(this).attr('name', inputId);
                $(this).attr('placeholder', 'Filter...');
            });

            let dataTableOb = settings.oInstance.api();
            let tableId = dataTableOb.table().node().id;
            if (tableId) {
                // Keep DataTables header widths stable without touching arbitrary existing stylesheets.
                applyTableWidthRules(tableId);
                applyResponsiveCardLabels(dataTableOb.table().node());
                enhanceDataTableShell(dataTableOb.table().node());

                // fix table header position after window resize
                resizedFinished[tableId] = null;
                $(window).on('resize', function () {
                    clearTimeout(resizedFinished[tableId]);
                    resizedFinished[tableId] = setTimeout(function () {
                        dataTableOb.fixedHeader.headerOffset(datatableHeaderOffset());
                    }, 50);
                });
            }
        },
        drawCallback: function (settings) {
            const wrapper = settings.nTableWrapper;
            const tableId = settings.nTable ? settings.nTable.id : null;
            const hrefTarget = tableId ? `#${tableId}` : '#';
            if (settings.nTable) {
                applyResponsiveCardLabels(settings.nTable);
                enhanceDataTableShell(settings.nTable);
            }
            if (wrapper) {
                $(wrapper).find('.dataTables_paginate a.paginate_button').each(function () {
                    if (!$(this).attr('href')) {
                        $(this).attr('href', hrefTarget);
                    }
                });
            }
            settings.oInstance.api().fixedHeader.adjust();
        }
    });

    // Homepage - /
    $(function () {
        applyResponsiveCardLabelsToAll();
        if (!document.querySelector('#homeStockStats')) return;
        homeStats();
        // $.when(homeStats()).done(function() { });
    });

    function addClassToTdNotTh(className) {
        return (td, cellData, rowData, rowIndex, colIndex) => {
            $(td).addClass(className);
        }
    };

    function isString(value) {
        return typeof value === 'string' || value instanceof String;
    }

    function isRenderableHref(value) {
        if (!isString(value)) return false;

        const href = value.trim();
        if (!href) return false;

        const normalized = href.toLowerCase();
        if (normalized === 'undefined' || normalized === 'null' || normalized === '#') return false;
        if (normalized === 'javascript:void(0)' || normalized === 'javascript:;') return false;

        return true;
    }

    function validateArray(data, col, columnType, arrayLength) {
        if (!Array.isArray(data)) {
            debug('Error: Column: ' + (col === null ? '(unknown)' : col + 1) + ': Wrong variable type for ' + columnType + ': ' + (typeof data) + ', value: ' + data + ', expected Array[' + arrayLength + ']');
            return false;
        }
        else if (data.length != arrayLength) {
            debug('Error: Column: ' + (col === null ? '(unknown)' : col + 1) + ': Wrong argument length: ' + data.length + ', value: ' + data + ', expected: Array[' + arrayLength + ']');
            return false;
        }
        return true;
    }

    function validateString(data, col, columnType) {
        if (isString(data) || data === null) {
            return true;
        }
        else {
            debug('Error: Column: ' + (col === null ? '(unknown)' : col + 1) + ': Wrong variable type for ' + columnType + ': ' + (typeof data) + ', value: ' + data + ', expected: string');
            return false;
        }
    }

    function validateNumber(data, col, columnType) {
        if (isNaN(data)) {
            debug('Error: Column: ' + (col === null ? '(unknown)' : col + 1) + ': Wrong variable type for ' + columnType + ': ' + (typeof data) + ', value: ' + data + ', expected: number');
            return false;
        }
        return true;
    }

    function dmy(dateString) {
        if (!dateString) return '';

        const date = new Date(dateString);
        if (isNaN(date)) {
            debug('Function dmy() data Error: ' + dateString);
            return '';
        }

        return formatDateForUI(date);
    }

    function formatDateForUI(dateString) {
        const date = new Date(dateString);
        if (isNaN(date)) return '';

        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            // hour: '2-digit',
            // minute: '2-digit',
            // hour12: false
        });
    }

    // https://stackoverflow.com/questions/7342957/how-do-you-round-to-one-decimal-place-in-javascript
    function round(value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }

    function errorHandler(xhr, status, error) {
        // alert only on production ENV
        if (railsEnv() == 'production') {
            alert('Sorry, something went wrong. You could try reloading the page');
        }
        else {
            console.log('URL: ' + this.url);
            console.log('Status: ' + xhr.status);
            console.log('Response: ' + xhr.responseText);
            // console.log(error);
            // console.log(this);
            // console.log(xhr);
        }
    }

    function parseBootstrapRows(scriptId) {
        const node = document.getElementById(scriptId);
        if (!node) return null;

        try {
            const payload = JSON.parse(node.textContent || '{}');
            if (Array.isArray(payload.data)) return payload.data;
        }
        catch (e) {
            debug('Failed to parse bootstrap rows from ' + scriptId + ': ' + e);
        }

        return null;
    }

    let centeredTextOptions = {
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('text-center');
            validateString(cellData, col, 'centeredTextOptions');
        },
    };

    let numberOptions = {
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('text-right');
            validateNumber(cellData, col, 'numberOptions');
        },
        orderSequence: ['desc', 'asc'],
        // TODO: ChatGPT suggested usage of numberFormat.js helper functions:
        // data: 'value',
        // render: function (data, type) {
        //     if (type === 'sort' || type === 'type') return data;
        //     return formatValue(data, 'USD', false);
        // },

        // data: 'value_change',
        // render: function (data, type) {
        //     if (type === 'sort') return data;

        //     const formatted = NumberFormatter.formatChange(
        //         data,
        //         v => NumberFormatter.formatValue(v, '$', true)
        //     );

        //     const cls = NumberFormatter.changeClass(data);
        //     return `<span class="${cls}">${formatted}</span>`;
        // },
        render: function (value, type, row) {
            if (type === 'display') {
                value = $.fn.dataTable.render.number(',', '.', 0).display(value);
            }
            else if (type === 'sort') {
                return value == null ? 0 : value;
            }

            return value;
        }
    };

    let humanOptions = {};

    ['number', 'USD'].forEach((unit) => {
        humanOptions[unit] = {
            createdCell: function (td, cellData, rowData, row, col) {
                $(td).addClass('text-right');
                validateNumber(cellData, col, 'humanOptions[' + unit + ']');
            },
            orderSequence: ['desc', 'asc'],
            render: function (value, type) {
                if (type === 'display' && value != null) {
                    return formatHuman(value, unit);
                }

                if (type === 'sort') {
                    return value == null ? 0 : Number(value);
                }

                return value;
            }
        };
    });

    let numberOptionsSign = {
        // createdCell: addClassToTdNotTh('text-right'),
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('text-right');
            validateNumber(cellData, col, 'numberOptionsSign');

            if (cellData < 0) {
                $(td).css('color', 'red')
            }
            else if (cellData > 0) {
                $(td).css('color', 'green')
            }
        },

        render: function (value, type, row) {
            if (type === 'display') {
                let val = $.fn.dataTable.render.number(',', '.', 0).display(value);

                if (value > 0) {
                    val = '+' + val;
                }
                else if (value == 0) {
                    val = ''
                }

                value = val
            }
            else if (type === 'sort') {
                return value == null ? 0 : value;
            }

            return value;
        }
    };

    let humanOptionsSign = {};

    ['number', 'USD'].forEach((unit) => {
        humanOptionsSign[unit] = {
            createdCell: function (td, cellData, rowData, row, col) {
                $(td).addClass('text-right');
                validateNumber(cellData, col, 'humanOptionsSign[' + unit + ']');

                if (cellData < 0) {
                    $(td).css('color', 'red');
                }
                else if (cellData > 0) {
                    $(td).css('color', 'green');
                }
            },
            render: function (value, type) {
                if (type === 'display' && value != null) {
                    const numericValue = typeof value === 'string'
                        ? Number(value.replace(/[^0-9.-]/g, ''))
                        : value;

                    if (numericValue === 0) {
                        return '';
                    }

                    const sign = numericValue > 0 ? '+' : '-';
                    const absValue = Math.abs(numericValue);

                    const formatted = formats[unit].human.format(absValue);

                    return sign + formatted;
                }

                if (type === 'sort') {
                    return value == null ? 0 : Number(value);
                }

                return value;
            }
        };
    });


    let decimalOptions = {
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('text-right');
            validateNumber(cellData, col, 'decimalOptions');
        },
        render: function (value, type, row) {
            if (type === 'display') {
                value = $.fn.dataTable.render.number(',', '.', 2).display(value);
            }
            else if (type === 'sort') {
                return value == null ? Infinity : value;
            }

            return value;
        }

    };

    // Price coming from backend is already formatted for display.
    // We only:
    //  - show it
    //  - keep raw numeric value for sorting
    //  - mark invalid prices with *
    //
    // Supported payloads:
    //  1) { price_display: "$123.45" | "82%", price_raw: 123.45 | 82, proper_price: true|false }
    //  2) legacy: [price_display, proper_price]
    //  3) legacy: "$123.45" / "82%"
    let priceProperOptions = {
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('text-right');

            // gray out if price is marked as not proper
            if (cellData && typeof cellData === 'object' && cellData.proper_price === false) {
                $(td).css('color', 'gray');
            }
            else if (Array.isArray(cellData) && cellData.length === 2 && cellData[1] === false) {
                $(td).css('color', 'gray');
            }
        },

        render: function (value, type, row) {
            let displayValue = '';
            let rawValue = null;
            let properPrice = true;

            // --- normalize payload ---
            // Backend is now the single source of truth for price formatting.
            // We only display what backend sends and keep a numeric raw value for sorting.

            if (value && typeof value === 'object' && !Array.isArray(value)) {
                // new API (preferred)
                displayValue = value.price_display;
                rawValue = value.price_raw;
                properPrice = value.proper_price !== false;
            }
            else if (Array.isArray(value) && value.length === 2) {
                // legacy API: [price_display, proper_price]
                displayValue = value[0];
                rawValue = Number(String(value[0]).replace(/[^0-9.-]/g, ''));
                properPrice = value[1] !== false;
            }
            else if (typeof value === 'string') {
                // already formatted string from backend
                displayValue = value;
                rawValue = Number(value.replace(/[^0-9.-]/g, ''));
            }
            else if (typeof value === 'number') {
                // numeric only – ensure string output for display consistency
                rawValue = value;
                displayValue = value.toString();
            }

            // --- render ---
            if (type === 'display') {
                let out = displayValue == null ? '' : displayValue.toString();

                if (!properPrice && out) {
                    out = out + '<sup>*</sup>';
                }

                return out;
            }

            if (type === 'sort') {
                return rawValue == null || isNaN(rawValue) ? 0 : rawValue;
            }

            return displayValue;
        }
    };

    let numberOrCurrencyOptions = {
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('text-right');
            validateArray(cellData, col, 'numberOrCurrencyOptions', 2);
        },
        render: function (data, type) {
            if (!Array.isArray(data) || data.length !== 2) {
                return data;
            }

            const [value, format] = data;

            if (type === 'display') {
                switch (format) {
                    case 'currency':
                    case 'USD':
                        return formatHuman(value, 'USD');

                    case 'number':
                        return formatHuman(value, 'number');

                    default:
                        return value;
                }
            }

            if (type === 'sort') {
                return value == null ? 0 : Number(value);
            }

            return value;
        }
    };

    // The parseFloat() function returns a floating-point number parsed from the given string or NaN if the first non-whitespace character cannot be converted to a number.
    // The Number.toFixed() method formats a number using fixed-point notation and can only be called on numbers.
    let pctOptions = {
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('text-right');
            validateNumber(cellData, col, 'pctOptions');
        },
        orderSequence: ['desc', 'asc'],
        render: function (pct, type, row) {
            if (type === 'display') {
                if (pct == null) {
                    return '';
                }
                else if (Math.abs(pct) > 0) {
                    let digits = Math.abs(pct) >= 10 ? 1 : 2;
                    return round(pct, digits) + '%';
                }
                // 0% case
                else {
                    return ''
                }
            }
            else if (type === 'sort') {
                if (pct == null) {
                    return '';
                }
            }

            return pct;
        }
    };

    let pctOptionsSign = {
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('text-right');
            validateNumber(cellData, col, 'pctOptionsSign');
        },
        orderSequence: ['desc', 'asc'],
        render: function (pct, type, row) {
            if (type === 'display') {
                let pct_string = '';
                if (pct == null) {
                    return '';
                }
                else if (Math.abs(pct) > 0) {
                    let digits = Math.abs(pct) >= 10 ? 1 : 2;
                    pct_string = round(pct, digits) + '%';
                    if (pct > 0) {
                        pct_string = '+' + pct_string;
                    }
                    return pct_string;
                }
                // 0% case
                else {
                    return ''
                }

            }
            else if (type === 'sort') {
                if (pct == null) {
                    return '';
                }
            }

            return pct;
        }
    };

    // only for portfolio_version data
    let comparisonPctOptions = {
        orderSequence: ['desc', 'asc'],
        createdCell: function (td, cellData, rowData, row, col) {
            let bgClass;
            $(td).addClass('text-right truncate hover:overflow-visible');
            validateNumber(cellData, col, 'comparisonPctOptions');

            if (cellData < 0) {
                $(td).css('color', 'red')
            }
            else if (cellData > 0) {
                $(td).css('color', 'green')
            }

            if (cellData === null) {
                bgClass = 'bg-green-100 hover:bg-green-200';
            } else if (cellData == -100) {
                bgClass = 'bg-red-100 bg-red-100 hover:bg-red-200';
            }
            $(td).parent().addClass(bgClass);
        },
        render: function (pct, type, row, meta) {
            if (type === 'display') {
                // return pct == null ? 'NEW' : Math.round(pct) + '%';
                let pct_string = '';

                if (pct == null) {
                    return 'NEW';
                }
                // else if (parseFloat(pct) == -100.0) {
                //   return 'SOLD OUT';
                // }
                else if (Math.abs(pct) > 0) {
                    let digits = Math.abs(pct) >= 10 ? 1 : 2;
                    pct_string = round(pct, digits) + '%';
                    if (pct > 0) {
                        pct_string = '+' + pct_string;
                    }
                    return pct_string;
                }
                else {
                    return ''
                }
            }
            else if (type === 'sort') {
                return pct == null ? Infinity : pct;
            }

            return pct;
        }
    };

    let miniPctOptions = {
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('text-right truncate');
            validateNumber(cellData, col, 'miniPctOptions');

            if (cellData < 0) {
                $(td).css('color', 'red')
            }
            else if (cellData > 0) {
                $(td).css('color', 'green')
            }
        },
        render: function (pct, type, row, meta) {
            if (type === 'display') {
                let pct_string = '';

                if (Math.abs(pct) > 0) {
                    pct_string = round(pct, 5) + '%';
                    if (pct > 0) {
                        pct_string = '+' + pct_string;
                    }
                    return pct_string;
                }
                else {
                    return ''
                }
            }
            else if (type === 'sort') {
                return pct == null ? Infinity : pct;
            }

            return pct;
        }
    };

    let otherManagerOptions = {
        createdCell: addClassToTdNotTh('text-center truncate')
    };

    let dateFiledOptions = {
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('text-right');
            validateString(cellData, col, 'dateFiledOptions');
        },
        render: function (data, type, row) {
            if (type === 'display') {
                return data == null ? '' : dmy(data);
            }

            return data;
        }
    };

    let dateLink = {
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('text-right');
            validateArray(cellData, col, 'dateLink', 2);
        },
        render: function (data, type, row) {
            if (Array.isArray(data)) {
                if (type === 'display') {
                    const dateLabel = dmy(data[0]);
                    if (!dateLabel) return '';

                    if (isRenderableHref(data[1])) {
                        return `<a href="${data[1]}">${dateLabel}</a>`;
                    }

                    return dateLabel;
                }
                return data[0];
            }

            return data;
        }
    };

    let overflowLink = {
        createdCell: function (td, cellData, rowData, row, col) {
            $(td).addClass('truncate group hover:overflow-visible');
            validateArray(cellData, col, 'overflowLink', 2);
        },
        render: function (data, type, row) {
            if (Array.isArray(data)) {
                if (isString(data[0]) && type === 'display' && data[0].trim().length) {
                    if (isRenderableHref(data[1])) {
                        return `<span class="overflow-label"><a href="${data[1]}">${data[0]}</a></span>`;
                    }

                    return `<span class="overflow-label">${data[0]}</span>`;
                }
                return data[0];
            }

            return data;
        }
    };

    let overflowOptions = {
        createdCell: function (td, cellData, rowData, row, col) {
            let bgClass;
            $(td).addClass('truncate group hover:overflow-visible');

            if (validateString(cellData, col, 'overflowOptions')) {
                if (cellData.includes('Purchase')) {
                    bgClass = 'bg-green-100 hover:bg-green-200';
                } else if (cellData.includes('Sale')) {
                    bgClass = 'bg-red-100 bg-red-100 hover:bg-red-200';
                }
                $(td).parent().addClass(bgClass);
            }
        },
        render: function (data, type, row) {
            if (isString(data) && type === 'display' && data.trim().length) {
                return `<span class="overflow-label">${data}</span>`;
            }

            return data;
        }
    };

    // https://stackoverflow.com/questions/65495442/how-to-use-one-ajax-datasource-with-multiple-jquery-datatables
    function homeStats() {
        if (!document.querySelector('#homeStockStats')) return;

        return $.ajax({
            cache: true,
            error: errorHandler,
            url: $('#homeStockStats').data('url'),
            success: function (data) {

                $('#homeStockStats').DataTable({
                    data: data.stocks,
                    buttons: buttonsDefault,
                    columns: [
                        overflowLink,
                        overflowLink,
                        humanOptionsSign['USD'],
                        humanOptionsSign['USD'],
                        humanOptionsSign['USD'],
                        numberOptionsSign,
                        numberOptionsSign,
                        numberOptionsSign,
                        decimalOptions,
                        decimalOptions,
                        dateFiledOptions,
                        dateFiledOptions
                    ],
                    columnDefs: [
                        { targets: [2, 4, 5, 7, 10, 11], orderSequence: ['desc', 'asc'] }
                    ],
                    searching: false,
                    // https://datatables.net/reference/option/dom
                    dom: 'l<"w-52"f>rti'
                });

                $('#homeSecurityStats').DataTable({
                    data: data.securities,
                    buttons: buttonsDefault,
                    columns: [
                        overflowLink,
                        overflowLink,
                        overflowOptions,
                        miniPctOptions,
                        miniPctOptions,
                        miniPctOptions,
                        numberOptionsSign,
                        numberOptionsSign,
                        numberOptionsSign,
                        decimalOptions,
                        humanOptionsSign['USD']
                    ],
                    columnDefs: [
                        { targets: [3, 5, 6, 8, 10], orderSequence: ['desc', 'asc'] }
                    ],
                    searching: false,
                    dom: 'l<"w-52"f>rti'
                });

            },
        });
    }

    // Portfolio show - /portfolio/000156761920015270-parallax-volatility-advisers-l-p-q2-2020
    $('#filingAggregated').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            dataSrc: function (json) {
                let portfolioChartData = {
                    labels: [],
                    urls: [],
                    data: [],
                    dataset_label: 'Holdings share',
                    unit: '%',
                    type: 'doughnut'
                };
                let data_visible_limit = 15;
                let rest_value = 0.0;
                let rest_count = 0;
                let holdings = json.data.filter(row => typeof row[1] === 'number' && row[1]);
                if (holdings.length == data_visible_limit + 1)
                    data_visible_limit++;
                holdings.forEach((row => {
                    if (data_visible_limit > 0) {
                        let company_label = row[3][0] + (row[0][0] ? ' (' + row[0][0] + ')' : '');
                        portfolioChartData.labels.push(company_label);
                        portfolioChartData.urls.push(row[0][1]);
                        portfolioChartData.data.push(row[1]);
                        data_visible_limit--;
                    }
                    else {
                        rest_value += row[1];
                        rest_count++;
                    }
                }
                ));
                if (portfolioChartData.data.length > 0 && rest_value > 0.0) {
                    portfolioChartData.labels.push('Other ' + rest_count + ' holdings');
                    portfolioChartData.data.push(rest_value);
                }
                if (portfolioChartData.data.length > 0) {
                    $('#portfolio-chart').closest('div.hidden').show();
                }
                mychart('portfolio-chart', [portfolioChartData]);

                return json.data;
            },
            error: errorHandler,
            url: $('#filingAggregated').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowLink,
            pctOptions,
            comparisonPctOptions,
            overflowLink,
            overflowOptions,
            humanOptionsSign['number'],
            comparisonPctOptions,
            humanOptionsSign['USD'],
            humanOptions['USD'],
            priceProperOptions,
            humanOptions['number'],
            humanOptions['USD']
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    // Portfolio show - /portfolio/000156761920015270-parallax-volatility-advisers-l-p-q2-2020
    $('#optionsAggregated').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            // dataSrc: function (json) {
            //     let portfolioChartData = {
            //         labels: [],
            //         data: [],
            //         dataset_label: 'Holdings share',
            //         unit: '%',
            //         type: 'doughnut'
            //     };
            //     let data_visible_limit = 15;
            //     let rest_value = 0.0;
            //     json.data.forEach((row => {
            //         if (typeof row[1] === 'number') {
            //             if (data_visible_limit > 0) {
            //                 let company_label = row[3][0] + (row[0][0] ? ' (' + row[0][0] + ')' : '');
            //                 portfolioChartData.labels.push(company_label);
            //                 portfolioChartData.data.push(row[1]);
            //                 data_visible_limit -= 1;
            //             }
            //             else {
            //                 rest_value += row[1];
            //             }
            //         }
            //     }
            //     ));
            //     if (portfolioChartData.data.length > 0 && rest_value > 0.0) {
            //         portfolioChartData.labels.push('Other holdings');
            //         portfolioChartData.data.push(rest_value);
            //     }
            //     if (portfolioChartData.data.length > 0) {
            //         $('#portfolio-chart').parent().parent().show();
            //     }
            //     mychart('portfolio-chart', [portfolioChartData]);

            //     return json.data;
            // },
            error: errorHandler,
            url: $('#optionsAggregated').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowLink,
            overflowLink,
            overflowOptions,
            overflowOptions,
            humanOptionsSign['number'],
            comparisonPctOptions,
            priceProperOptions,
            humanOptions['number'],
            humanOptions['USD']
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    // Portfolio detailed
    // /portfolio/000156761920015270-parallax-volatility-advisers-l-p-q2-2020/detailed
    $('#filingDetailed').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            dataSrc: function (json) {
                let fallbackNotice = $('#filingDetailedFallbackNotice');
                let fallbackMode = json && json.meta && json.meta.fallback_mode;
                if (fallbackMode && fallbackNotice.length) {
                    fallbackNotice.text(json.meta.fallback_message || 'Szczegoly archiwalne ograniczone (retencja danych detailed).');
                    fallbackNotice.removeClass('hidden');
                } else if (fallbackNotice.length) {
                    fallbackNotice.addClass('hidden');
                    fallbackNotice.text('');
                }
                return json.data;
            },
            error: errorHandler,
            url: $('#filingDetailed').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowLink,
            pctOptions,
            overflowLink,
            overflowOptions,
            centeredTextOptions,
            humanOptions['USD'],
            humanOptions['number'],
            humanOptions['number'],
            centeredTextOptions,
            otherManagerOptions,
            humanOptions['number'],
            humanOptions['number'],
            humanOptions['number']
        ],
        columnDefs: [
            { targets: [10, 11, 12], width: '8rem', className: 'truncate' }
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    // Compare
    // /portfolio/000108636423000015/compare/000083423722010526
    $('#filingComparison').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            error: errorHandler,
            url: $('#filingComparison').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowOptions,
            overflowLink,
            overflowOptions,
            centeredTextOptions,
            humanOptions['number'],
            humanOptions['number'],
            humanOptionsSign['number'],
            comparisonPctOptions,
            humanOptions['USD'],
            humanOptions['USD'],
            humanOptionsSign['USD'],
            comparisonPctOptions
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    // Security Holdings by quarter
    // /investment/037833100/2023/1
    $('#allSecurityHolders').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            dataSrc: function (json) {
                // let val = $.fn.dataTable.render.number(',', '.', 0, '$').display(json.total_value);
                // $('.total-value').html(val);
                return json.data;
            },
            error: errorHandler,
            url: $('#allSecurityHolders').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowLink,
            centeredTextOptions,
            pctOptions,
            comparisonPctOptions,
            humanOptions['USD'],
            priceProperOptions,
            humanOptions['number'],
            humanOptionsSign['number'],
            comparisonPctOptions,
            dateLink
        ],
        columnDefs: [
            { targets: [2, 3, 4], orderSequence: ['desc', 'asc'] }
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    $('#securityInvestorsCompare').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            error: errorHandler,
            url: $('#securityInvestorsCompare').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowLink,
            humanOptions['number'],
            humanOptions['number'],
            humanOptionsSign['number'],
            comparisonPctOptions,
            humanOptions['USD'],
            humanOptions['USD'],
            humanOptionsSign['USD'],
            comparisonPctOptions
        ],
        columnDefs: [
            { targets: [1, 2, 3, 5, 6, 7], orderSequence: ['desc', 'asc'] }
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    // Investor Show
    // /investor/0001364742-blackrock-inc
    $('#investorFilings').DataTable(publicAjaxTableOptions({
        columnDefs: [
            { targets: [1, 2, 3, 4, 5], orderSequence: ['desc', 'asc'] }
        ],
        searching: false,
        dom: 'l<"w-52"f>rtpi'
    }));

    // CompanyTag
    // /stock-tag/meta/ratio/ROA/USD?freq=Y
    $('#companyTags, #companyTagsRatio, #companyTagsInstant, #companyTagsInstantRatio, #companyTagsYear, #companyTagsYearRatio').DataTable(publicAjaxTableOptions({
        columnDefs: [
            { targets: [0, 1, 2, 3, 4], orderSequence: ['desc', 'asc'] }
        ],
        searching: false,
        dom: 'l<"w-52"f>rtpi'
    }));

    // Insider show
    // /insider/0001295231-page-lawrence
    $('#insiderClasses').DataTable({
        columnDefs: [
            { targets: [4], orderSequence: ['desc', 'asc'] }
        ],
        searching: false,
        dom: 'l<"w-52"f>rtpi'
    });

    $('#insiderTransactionsAggregated').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            error: errorHandler,
            url: $('#insiderTransactionsAggregated').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowOptions,
            overflowLink,
            overflowOptions,
            overflowOptions,
            pctOptionsSign,
            humanOptions['USD'],
            priceProperOptions,
            humanOptionsSign['number'],
            numberOrCurrencyOptions,
            dateFiledOptions,
            overflowOptions
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    $('#investorSchedules').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            error: errorHandler,
            url: $('#investorSchedules').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowOptions, // symbol
            overflowLink, // Target
            overflowLink, // class
            pctOptions, // ownership
            miniPctOptions, // ownership change %
            humanOptions['number'], // shares owned
            miniPctOptions, // share change %
            humanOptions['USD'], // value
            overflowOptions, // reporting name
            overflowOptions, // form
            dateFiledOptions,
            dateFiledOptions
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    // Stock show
    // /stock/goog
    // tables should be initialized in the same order as in html
    $('#stockBuysSells').DataTable({
        searching: false,
        dom: 'l<"w-52"f>rti'
    });

    $('#insiderStockBuysSells').DataTable({
        searching: false,
        dom: 'l<"w-52"f>rti'
    });

    $('#stockClasses').DataTable(publicAjaxTableOptions({
        searching: false,
        dom: 'l<"w-52"f>rti'
    }));

    $('#stockInsiders').DataTable(publicAjaxTableOptions({
        searching: false,
        columnDefs: [
            { targets: [3, 4], orderSequence: ['desc', 'asc'] }
        ],
        dom: 'l<"w-52"f>rtpi'
    }));

    const stockTransactionsRows = parseBootstrapRows('stockTransactionsAggregatedData');
    const stockTransactionsTable = $('#stockTransactionsAggregated');
    const stockTransactionsEmptyMessage = stockTransactionsTable.data('emptyMessage');
    const stockTransactionsOptions = publicAjaxTableOptions({
        buttons: buttonsDefault,
        columns: [
            overflowLink,
            overflowOptions,
            overflowLink,
            overflowOptions,
            pctOptionsSign,
            humanOptions['USD'],
            priceProperOptions,
            humanOptionsSign['number'],
            numberOrCurrencyOptions,
            dateFiledOptions,
            overflowOptions
        ],
        language: {
            emptyTable: stockTransactionsEmptyMessage || 'No data available in table'
        },
        dom: 'l<"w-52"f>rtpiB'
    });

    if (Array.isArray(stockTransactionsRows)) {
        // Server-rendered rows are fallback-only (for no-JS/failed-JS). Remove them before DataTables data init.
        stockTransactionsTable.find('tbody').empty();
        stockTransactionsOptions.data = stockTransactionsRows;
    }
    else {
        stockTransactionsOptions.ajax = {
            cache: true,
            error: errorHandler,
            url: stockTransactionsTable.data('url')
        };
    }

    stockTransactionsTable.DataTable(stockTransactionsOptions);

    // Insider Stock
    // /insider/0001219112/stock/0000104169
    $('#InsiderSecurities').DataTable({
        columnDefs: [
            { targets: [2], orderSequence: ['desc', 'asc'] }
        ],
        searching: false,
        dom: 'l<"w-52"f>rtpi'
    });

    $('#insiderStockTransactions').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            error: errorHandler,
            url: $('#insiderStockTransactions').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowOptions,
            overflowLink,
            overflowOptions,
            pctOptionsSign,
            humanOptions['USD'],
            priceProperOptions,
            humanOptionsSign['number'],
            numberOrCurrencyOptions,
            dateFiledOptions,
            overflowOptions
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    // Stock Stats
    // /stock-stats/m3
    $('#stockStats').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            error: errorHandler,
            url: $('#stockStats').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowLink,
            overflowLink,
            humanOptionsSign['USD'],
            humanOptionsSign['USD'],
            humanOptionsSign['USD'],
            numberOptionsSign,
            numberOptionsSign,
            numberOptionsSign,
            decimalOptions,
            decimalOptions,
            dateFiledOptions,
            dateFiledOptions
        ],
        columnDefs: [
            { targets: [2, 4, 5, 7, 10, 11], orderSequence: ['desc', 'asc'] }
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    // Stock Stats
    // /stock-stats/m3
    $('#securityStats').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            error: errorHandler,
            url: $('#securityStats').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowLink,
            overflowLink,
            overflowOptions,
            miniPctOptions,
            miniPctOptions,
            miniPctOptions,
            numberOptionsSign,
            numberOptionsSign,
            numberOptionsSign,
            decimalOptions,
            humanOptionsSign['USD']
        ],
        columnDefs: [
            { targets: [3, 5, 6, 8, 10], orderSequence: ['desc', 'asc'] }
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    // Grand Portfolio
    // /grand-portfolio
    $('#grandPortfolio').DataTable(publicAjaxTableOptions({
        ajax: {
            cache: true,
            error: errorHandler,
            url: $('#grandPortfolio').data('url')
        },
        buttons: buttonsDefault,
        columns: [
            overflowLink,
            overflowLink,
            overflowOptions,
            pctOptions,
            miniPctOptions,
            numberOptions,
            decimalOptions,
            humanOptions['USD'],
            humanOptionsSign['USD']
        ],
        columnDefs: [
            { targets: [3, 4, 5, 7, 8], orderSequence: ['desc', 'asc'] }
        ],
        dom: 'l<"w-52"f>rtpiB'
    }));

    // Insider reports
    // /insider/0001295084-shriram-kavitark-ram/reports
    $('#insiderStocks').DataTable({
        columnDefs: [
            { targets: [3], orderSequence: ['desc', 'asc'] }
        ],
        searching: false,
        dom: 'l<"w-52"f>rti'
    });

    $('#insiderFilings').DataTable({
        columnDefs: [
            { targets: [2, 3], orderSequence: ['desc', 'asc'] }
        ],
        searching: false,
        dom: 'l<"w-52"f>rtpi'
    });

    // Insider Report
    // /report/000162828023027380-shahar-shai-2023-08-01
    $('#insiderTransactions').DataTable({
        columnDefs: [
            { targets: [5, 6, 7, 8], orderSequence: ['desc', 'asc'] }
        ],
        searching: false,
        dom: 'l<"w-52"f>rti'
    });

    $('#insiderDerivatives').DataTable({
        columnDefs: [
            { targets: [5, 6, 7, 8], orderSequence: ['desc', 'asc'] }
        ],
        searching: false,
        dom: 'l<"w-52"f>rti'
    });

    // Submissions
    // /submissions/googl/SC13G
    $('#submissions').DataTable({
        columnDefs: [
            { targets: [3, 4], orderSequence: ['desc', 'asc'] }
        ],
        dom: 'l<"w-52"f>rtpi'
    });

    // /13dg/0000019617-jpmorgan-chase-co
    $('#investorSecurityHistory').DataTable(publicAjaxTableOptions({
        dom: 'l<"w-52"f>rtpi'
    }));

    $('#investorSecurities, #reportingPersons, #insiderReportingPersons, #securityQuarters, #institutionalOwnership').DataTable(publicAjaxTableOptions({
        searching: false,
        dom: 'l<"w-52"f>rtpi'
    }));

    const adminSearchZeroGlobalTable = $('#adminSearchZeroTopGlobal');
    if (adminSearchZeroGlobalTable.length && !$.fn.dataTable.isDataTable(adminSearchZeroGlobalTable)) {
        adminSearchZeroGlobalTable.DataTable({
            buttons: buttonsDefault,
            columnDefs: [
                { targets: [1, 2, 3], orderSequence: ['desc', 'asc'] }
            ],
            order: [[1, 'desc'], [2, 'desc']],
            pageLength: 25,
            searching: true,
            dom: 'l<"w-52"f>rtpiB'
        });
    }

    const adminSearchZeroByDayTable = $('#adminSearchZeroTopByDay');
    if (adminSearchZeroByDayTable.length && !$.fn.dataTable.isDataTable(adminSearchZeroByDayTable)) {
        adminSearchZeroByDayTable.DataTable({
            buttons: buttonsDefault,
            columnDefs: [
                { targets: [2, 3, 4], orderSequence: ['desc', 'asc'] }
            ],
            order: [[0, 'desc'], [2, 'desc']],
            pageLength: 50,
            searching: true,
            dom: 'l<"w-52"f>rtpiB'
        });
    }

});
